import React, { Fragment, ReactNode, useState } from "react";
import S from "./Header.style";
import { usePressData } from "@/components/layout-blocks/PressReleases/usePressData";
import { useLocalization } from "@/contexts/Localization";
import { useHeroReportData } from "@/components/layout-blocks/MainHero/useHeroReportsData";
import { useHeroArticlesData } from "@/components/layout-blocks/MainHero/useHeroArticlesData";
import { useBlogData } from "@/components/layout-blocks/Blog/useBlogData";

export type ILink = {
    description?: string;
    sublink: [
        link: {
            link: {
                url: string;
                title: string;
            },
            description: string;
        }
    ]
    title: string;
    url: {
        url: string;
        title: string;
    }
};

type PressData = {
    uri: string;
    title: ReactNode;
    date: string;
};

type Props = {
    links: ILink[];
    list: string;
    toggleDropdown: [boolean, string];
    setToggleDropdown: Function;
};

const Menu: React.FC<Props> = ({ links, toggleDropdown }) => {
    const { language } = useLocalization();

    const pressData = usePressData('sv'); // Default list data
    const stickyReports = useHeroReportData();
    const stickyArticles = useHeroArticlesData();
    const blogData = useBlogData('sv');

    const [pData, _] = useState<PressData[]>(pressData);
    const [rData, __] = useState(stickyReports);
    const [aData, ___] = useState(stickyArticles);
    const [bData, ____] = useState(blogData);

    const mix = [rData[0], aData[0], bData[0], rData[1], aData[1], bData[1]]
    const list = toggleDropdown[1]?.replace(/^[^\.]*\./, '');
    const listItems = ['press', 'blog', 'articles', 'mix', 'reports']

    return (
        <S.Dropdown>
            {
                list === 'mix' &&
                <S.LatestPress>
                    <S.PressTitle>{language === 'en' ? 'Mixed Insights:' : 'Blandade Insikter:'}</S.PressTitle>
                    <S.PressContainer>
                        {mix.map(({ uri, title, date, published_at, publishedAt }, i) => (
                            <S.PressLink href={uri} key={i}>
                                <p>{title}</p>
                                <span>{(new Date(date ? date : (publishedAt ? publishedAt : published_at))).toLocaleDateString('sv-SE', { month: 'short', day: 'numeric' })}</span>
                            </S.PressLink>
                        ))}
                    </S.PressContainer>
                </S.LatestPress>
            }
            {
                list === 'blog' &&
                <S.LatestPress>
                    <S.PressTitle>{language === 'en' ? 'Latest Blog:' : 'Senaste Blogg:'}</S.PressTitle>
                    <S.PressContainer>
                        {bData.slice(0, 5).map(({ uri, title, date }, i) => (
                            <S.PressLink href={uri} key={i}>
                                <p>{title}</p>
                                <span>{(new Date(date)).toLocaleDateString('sv-SE', { month: 'short', day: 'numeric' })}</span>
                            </S.PressLink>
                        ))}
                    </S.PressContainer>
                </S.LatestPress>
            }
            {list === 'press' &&
                <S.LatestPress>
                    <S.PressTitle>{language === 'en' ? 'Latest Press:' : 'Senaste Pressmedelanden:'}</S.PressTitle>
                    <S.PressContainer>
                        {pData.slice(0, 5).map(({ uri, title, date }, i) => (
                            <S.PressLink href={uri} key={i}>
                                <p>{title}</p>
                                <span>{date}</span>
                            </S.PressLink>
                        ))}
                    </S.PressContainer>
                </S.LatestPress>
            }
            {(list === '' || !list || !listItems.includes(list)) &&
                <S.LatestPress>
                    <S.PressTitle>{language === 'en' ? 'empty:' : 'empty:'}</S.PressTitle>
                    <S.PressContainer>
                        {list}
                    </S.PressContainer>
                </S.LatestPress>
            }
            {list === 'reports' &&
                <S.LatestPress>
                    <S.PressTitle>{language === 'en' ? 'Latest Reports:' : 'Senaste Rapporter:'}</S.PressTitle>
                    <S.PressContainer>
                        {rData.slice(0, 5).map(({ url, title, published_at, description }, i) => (
                            <S.PressLink href={url} key={i}>
                                <p>{title}: {description.slice(0, 50)}...</p>
                                <span>{(new Date(published_at)).toLocaleDateString('sv-SE', { month: 'short', day: 'numeric' })}</span>
                            </S.PressLink>
                        ))}
                    </S.PressContainer>
                </S.LatestPress>
            }
            {list === 'articles' &&
                <S.LatestPress>
                    <S.PressTitle>{language === 'en' ? 'Latest Articles:' : 'Senaste Artiklar:'}</S.PressTitle>
                    <S.PressContainer>
                        {aData.slice(0, 5).map(({ url, title, publishedAt, preamble }, i) => (
                            <S.PressLink href={url} key={i}>
                                <p>{title}: {preamble.slice(0, 50)}...</p>
                                <span>{(new Date(publishedAt)).toLocaleDateString('sv-SE', { month: 'short', day: 'numeric' })}</span>
                            </S.PressLink>
                        ))}
                    </S.PressContainer>
                </S.LatestPress>
            }
            <S.MenuContainer>
                {
                    links.map(({ subLinks, link }, i) => {

                        if (toggleDropdown[1]?.replace(/\.(.*)/, '') !== link.title?.replace(/\.(.*)/, '') && subLinks) {
                            return;
                        }

                        return (
                            <Fragment key={i} >
                                {subLinks &&
                                    <S.TitleHeader href={link.url} target={''}>
                                        {link.title?.replace(/\.(.*)/, '')}
                                    </S.TitleHeader>
                                }
                                <S.ContainerDiv>
                                    {
                                        subLinks && subLinks.map((o: { subLink: { url: any; title: string; }; }) =>
                                            <S.DropdownLink
                                                href={o.subLink && o.subLink.url}>
                                                {o.subLink && o.subLink.title.split('.')[0]}
                                                <S.Description>{o.subLink && o.subLink.title.split('.')[1]}</S.Description>
                                            </S.DropdownLink>
                                        )
                                    }
                                </S.ContainerDiv>
                            </Fragment>
                        )
                    })}
            </S.MenuContainer>
        </S.Dropdown >
    );
};

export default Menu;
